module.exports = __webpack_public_path__ + "media/images/landing/en/save_time-ad04ceed5f772a1e224450a582548544.webp";